import {memo} from 'react'

import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import {Button, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Body1, Headline1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import {DRAWER_TYPES} from '../../drawers/config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-reportAd`

const ReportAd = ({ad = {}, onOpenDrawer, seller = {}}) => {
  const {domain, i18n} = useSuiContext()

  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !domain.get('config').get('isMobile')
  })

  const handleClick = () => {
    onOpenDrawer({data: {adId: ad.id, isProfessional: Boolean(seller.isDealer)}, type: DRAWER_TYPES.REPORT_AD})
  }

  return (
    <section className={BASE_CLASS}>
      <Headline1>{i18n.t('AD_COMPLAINT.PANEL_TITLE')}</Headline1>
      <Body1 className={`${BASE_CLASS}-subtitle`}>{i18n.t('AD_COMPLAINT.PANEL_SUBTITLE')}</Body1>
      <Button
        fullWidth={!isHigherThanMobile}
        onClick={handleClick}
        shape={BUTTON_SHAPES.CIRCLE}
        variant={BUTTON_VARIANTS.OUTLINE}
        size={isHigherThanMobile ? BUTTON_SIZES.MEDIUM : BUTTON_SIZES.LARGE}
      >
        {i18n.t('AD_COMPLAINT.TO_COMPLAINT_AD')}
      </Button>
    </section>
  )
}

ReportAd.displayName = 'ReportAd'

ReportAd.propTypes = {
  ad: PropTypes.shape({
    id: PropTypes.string
  }),
  onOpenDrawer: PropTypes.func.isRequired,
  seller: PropTypes.shape({
    isDealer: PropTypes.bool
  })
}

export default memo(ReportAd)
